export function genURLParams (params) {
  // 生成URL参数
  if (params === null || params === undefined) {
    return ''
  }

  let sb = ''

  for (var field in params) {

    if (params[field] === null || params[field] === undefined) {
      continue
    }

    if (params[field] instanceof Array) {
      let subParams = params[field]
      for (var subField in subParams) {
        sb = sb + field + '=' + subParams[subField] + '&'
      }

    } else {
      sb = sb + field + '=' + params[field] + '&'
    }
  }

  if (sb.length > 1) {
    sb = '?' + sb.substr(0, sb.length - 1)
  }

  return sb

}
